import React, { FC, useState } from 'react'
import { Row, Col, Image } from 'react-bootstrap'
import { withRouter, RouteComponentProps } from 'react-router-dom'

import ForgotPasswordForm from './ForgotPasswordForm'
import LoginLayout from '../layout'
import mavLogo from '../../../assets/img/gray_logo.svg'
import './styles.scss'

interface Props extends RouteComponentProps {
  setLoginStage: (loginStage: 'reset' | 'signup') => void
}

const ForgotPassword: FC<Props> = ({ history, setLoginStage }) => {
  const [sentCode, setSentCode] = useState(false)

  return (
    <LoginLayout>
      <div className="forgot-password">
        {sentCode ? (
          <Row className="feedback">
            <Col>
              <h5>Check your email for an email with a verification code.</h5>
              <h5>Open the email and you will be prompted to reset your password.</h5>
            </Col>
          </Row>
        ) : (
          <>
            <Image src={mavLogo} alt="Placeholder" className="logo-img" />
            <Row className="title">
              <Col>
                <h1>Forgot Password?</h1>
              </Col>
            </Row>
            <Row className="info">
              <Col>
                <p>Don&apos;t worry, this happens to everyone...</p>
                <p>Drop us your email address and we&apos;ll send a link to reset your password.</p>
              </Col>
            </Row>
            <Row className="form">
              <Col>
                <ForgotPasswordForm setSentCode={setSentCode} setLoginStage={setLoginStage} />
                <button
                  className="link_btn"
                  onClick={(): void => history.push('/login')}
                  onKeyDown={(): void => {}}
                  type="button"
                >
                  Go Back
                </button>
              </Col>
            </Row>
          </>
        )}
      </div>
    </LoginLayout>
  )
}

export default withRouter(ForgotPassword)
